import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
import { mapRepairProductToServer } from "./mappers/mapRepairProductToServer";
export const updateRepairProduct = async (sessionKey, product) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/update/product`,
            method: "PUT",
            data: mapRepairProductToServer(product),
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
